import React, { useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import AddAppointmentModal from 'components/ui/tailwind/modals/AddAppointmentModal';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
export default function AppointmentWindowNextSteps({ item, shipment }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const { stops } = shipment;
    const stop = stops.find((s) => { var _a; return s._id === ((_a = item === null || item === void 0 ? void 0 : item.meta) === null || _a === void 0 ? void 0 : _a.stop); });
    const renderAppointmentLabel = (stop) => {
        const window = item.field === 'window_start' ? 'SET' : 'CONFIRM';
        const offsite = (stop === null || stop === void 0 ? void 0 : stop.off_site) ? '_OFFSITE' : '';
        const empty = (stop === null || stop === void 0 ? void 0 : stop.empty) ? '_EMPTY' : '';
        const action = (stop === null || stop === void 0 ? void 0 : stop.action) === 'deliver' ? '_DELIVERY' : '_PICKUP';
        return `${window}${offsite}${empty}${action}`;
    };
    const renderIcon = () => {
        return !item.complete ? (React.createElement(CalendarIcon, { type: "solid", className: "w-5 h-5" })) : (React.createElement("div", { "data-testid": "div-9910d49b", className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    const handleSave = (data) => {
        ShipmentsActionCreators.updateShipmentStopWindow(shipment, stop, data);
        setShowModal(false);
    };
    return ((React.createElement("div", { "data-testid": "div-3270aa78" },
        React.createElement("div", { "data-testid": "div-34780d8c", className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", { "data-testid": "span-80f0c201" }, t(renderAppointmentLabel(stop))),
            React.createElement(CircleButton, { dataTestId: "CircleButton-8a7f73f4", size: "small", disabled: item.complete, onClick: () => setShowModal(true) }, renderIcon())),
        showModal && (React.createElement(AddAppointmentModal, { dataTestId: "AddAppointmentModal-182483dd", show: showModal, stop: stop, shipment: shipment, onSave: handleSave, onHide: () => setShowModal(false) })))));
}
